import React, { Component } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CCardHeader,
  CTextarea,
  CCardFooter,
  CBadge,
  CInput,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CFormGroup,
  CLabel,
  CCollapse
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import { formatDate } from "../../utils/date";

class EducationPlanCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // loading: true,
      // publishLoading: false,
      // plans: null,
      // tab: 1,
      // title: "",
      // observation: "",
      // selectModal: false,
      // selectedResources: [],
      // selectedMethods: [],
      // roles: [],
      // selectedRoles: "Todos",
      // classes: 1,
      classDates:
        props.plan?.dates?.map(date =>
          date.executions.length > 0 ? date.executions[0].effective_date : null
        ) || [],
      classObservations:
        props.plan?.dates?.map(date =>
          date.executions.length > 0 ? date.executions[0].observation : null
        ) || [],
      // series: [],
      // serie_id: 0,
      // periods: [],
      // period_id: 0,
      // curricula: [],
      // curriculum_id: null,
      collapse: null
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  deletePlan() {
    this.setState({ deleteModal: false });

    axios
      .post(`${URL.api}education/plan/delete/${this.props.plan?.id}`, null, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success === false) {
            this.error("Falha ao apagar o plano de ensino");
          } else {
            this.props.onReload();
          }
        },
        error => {
          this.error("Falha ao apagar o plano de ensino");
        }
      );
  }

  saveDate(id, index) {
    const date = this.state.classDates[index];
    const observation = this.state.classObservations[index];

    if (date) {
      axios
        .post(
          `${URL.api}education/execution_plan/insert`,
          {
            effective_date: date,
            observation,
            plan_date_id: id
          },
          {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(
          resp => {
            if (resp.data.success === false) {
              this.error("Falha ao salvar a data");
            } else {
              this.props.onReload();
              this.setState({ collapse: null });
            }
          },
          error => {
            this.error("Falha ao salvar a data");
          }
        );
    }
  }

  render() {
    const plan = this.props.plan;

    return (
      <>
        {this.state.deleteModal && (
          <CModal
            show
            onClose={() => this.setState({ deleteModal: false })}
            closeOnBackdrop={false}
          >
            <CModalHeader closeButton className="bg-danger">
              <CModalTitle>Apagar plano de ensino</CModalTitle>
            </CModalHeader>
            <CModalBody>
              Deseja apagar o plano de ensino selecionado?
            </CModalBody>
            <CModalFooter>
              <CButton color="danger" onClick={() => this.deletePlan()}>
                Apagar
              </CButton>{" "}
              <CButton
                color="secondary"
                onClick={() => this.setState({ deleteModal: false })}
              >
                Cancelar
              </CButton>
            </CModalFooter>
          </CModal>
        )}
        <CCard>
          <CCardHeader>
            <div className="d-flex align-items-center">
              <div className="c-avatar mr-3">
                <img
                  className="c-avatar-img"
                  src={
                    URL.img +
                    (plan.user.photo || "uploads/users/profileEmpty.jpg")
                  }
                  alt=""
                />
              </div>
              <div className="d-block w-100">
                <div className="d-flex">
                  <span
                    className="d-flex font-weight-bold"
                    style={{ flex: 1, fontSize: "1rem" }}
                  >
                    {plan.user.name}
                  </span>
                  {this.props.user.user.id === plan.user.id && (
                    <CDropdown className="card-notice-menu position-absolute">
                      <CDropdownToggle
                        color="white"
                        className="card-header-action remove-caret"
                      >
                        <i className="fa fa-ellipsis-v"></i>
                      </CDropdownToggle>
                      <CDropdownMenu placement="top">
                        <CDropdownItem
                          onClick={() =>
                            this.setState({
                              deleteModal: true
                              // deleteId: plan.id
                            })
                          }
                        >
                          Apagar
                        </CDropdownItem>
                      </CDropdownMenu>
                    </CDropdown>
                  )}
                </div>
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <div>
              <div style={{ fontWeight: "bold" }}>
                ({plan.curriculum?.ability?.code}){" "}
                {plan.curriculum?.ability?.description}
              </div>
            </div>
            <div className="mt-2 text-muted">
              {plan.curriculum?.code || "Currículo"} |{" "}
              {plan.curriculum?.serie?.name} |{" "}
              {plan.curriculum?.period?.description}
            </div>
            <div className="d-flex justify-content-start mt-2">
              {plan.resources?.map(resource => (
                <CBadge
                  color="primary"
                  className={`mfe-2 p-2 cursor btn-${"primary"}`}
                >
                  <i className="fa fa-puzzle-piece mr-2"></i>
                  {resource.resource?.description}
                </CBadge>
              ))}
              {plan.methods?.map(method => (
                <CBadge
                  color="warning"
                  className={`mfe-2 p-2 cursor btn-${"warning"}`}
                >
                  <i className="fa fa-gears mr-2"></i>
                  {method.method?.description}
                </CBadge>
              ))}
            </div>
            {plan.other_methods && (
              <div className="mt-2 text-muted">
                <strong>Outros métodos: </strong>
                {plan.other_methods}
              </div>
            )}
            {plan.other_resources && (
              <div className="mt-2 text-muted">
                <strong>Outros recursos: </strong>
                {plan.other_resources}
              </div>
            )}
            {plan.evaluation && (
              <div className="mt-2 text-muted">
                <strong>Avaliação: </strong>
                {plan.evaluation}
              </div>
            )}
            {plan.observation && (
              <div className="mt-2 text-muted">
                <strong>Observação: </strong>
                {plan.observation}
              </div>
            )}
          </CCardBody>
          {plan.dates?.length > 0 && (
            <CCardFooter className="d-flex flex-column justify-content-start pb-0">
              {plan.dates?.map((item, index) => (
                <CFormGroup className="" key={index}>
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <CLabel className="m-0">
                      <strong>{index + 1}ª aula: </strong>
                      {formatDate(item.date).substring(0, 10)}
                      {item.executions.length > 0 && (
                        <i className="fa fa-check-circle ml-2 text-success"></i>
                      )}
                    </CLabel>
                    <i
                      onClick={() =>
                        this.setState(state => ({
                          collapse: state.collapse === index ? null : index
                        }))
                      }
                      className={`text-muted activity-collapse fa fa-chevron-${
                        this.state.showCreate ? "up" : "down"
                      }`}
                    ></i>
                  </div>
                  <CCollapse show={this.state.collapse === index}>
                    <div className="mt-2">
                      <CLabel>Data efetiva</CLabel>
                      <CInput
                        type="date"
                        className="mb-2"
                        value={
                          this.state.classDates[index]
                            ? this.state.classDates[index].substring(0, 10)
                            : ""
                        }
                        onChange={e => {
                          // eslint-disable-next-line react/no-access-state-in-setstate
                          const newDates = this.state.classDates;
                          newDates[index] = e.target.value;
                          this.setState({ classDates: newDates });
                        }}
                      />
                      <CLabel>Observação</CLabel>
                      <CTextarea
                        rows={2}
                        placeholder="Observação"
                        value={this.state.classObservations[index] || ""}
                        onChange={e => {
                          // eslint-disable-next-line react/no-access-state-in-setstate
                          const newObservations = this.state.classObservations;
                          newObservations[index] = e.target.value;
                          this.setState({ classObservations: newObservations });
                        }}
                        className="mb-2"
                      />
                      <CButton
                        color="primary"
                        style={{ whiteSpace: "nowrap", float: "right" }}
                        onClick={() => this.saveDate(item.id, index)}
                      >
                        Salvar
                      </CButton>
                    </div>
                  </CCollapse>
                </CFormGroup>
              ))}
            </CCardFooter>
          )}
        </CCard>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EducationPlanCard);
